import { useEffect } from 'react'

type IndexUpdater = (index: number | ((prev: number) => number)) => void

export const useKeyboardNavigation = (
    isOpen: boolean,
    itemCount: number,
    activeIndex: number,
    onOpenChange: (v: boolean) => void,
    onIndexChange: IndexUpdater,
    onSelect: (optionIndex: number) => void,
) => {
    useEffect(() => {
        if (typeof window === 'undefined') return
        const handleKey = (e: KeyboardEvent) => {
            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault()
                    onIndexChange((prev: number) => Math.min(prev + 1, itemCount - 1))
                    break
                case 'ArrowUp':
                    e.preventDefault()
                    onIndexChange((prev: number) => Math.max(prev - 1, -1))
                    break
                case 'Enter':
                    e.preventDefault()
                    if (activeIndex >= 0) onSelect(activeIndex)
                    break
                case 'Escape':
                    e.preventDefault()
                    onOpenChange(false)
                    onIndexChange(-1)
                    break
                default:
                    break
            }
        }
        document.addEventListener('keydown', handleKey)
        return () => document.removeEventListener('keydown', handleKey)
    }, [isOpen, itemCount, activeIndex, onOpenChange, onIndexChange, onSelect])
}

export default useKeyboardNavigation
